import React, { useState } from 'react';
import OperacoesOffline from './pages/OperacoesOffline/OperacoesOffline';
import Login from './components/Login/Login';
import { estaAutenticado, encerrarSessao } from './utils/auth';
import './App.css';

function App() {
  const [sessao, setSessao] = useState(() => estaAutenticado());

  if (!sessao) {
    return <Login onLogin={setSessao} />;
  }

  function handleSignOut() {
    encerrarSessao();
    setSessao(null);
  }

  return (
    <>
      <OperacoesOffline sessao={sessao} onSignOut={handleSignOut} />
    </>
  );
}

export default App;
